import ServiceBase from '../ServiceBase';

export default class TranslationsAdminService extends ServiceBase {
    getTranslationModel({
        projectID,
        formType,
        languageIsoCode,
        entityID,
    }) {
        return this.request('post', 'admin/translations/getTranslationModel', {
            projectID,
            formType,
            languageIsoCode,
            entityID,
        });
    }

    getTranslationModelList({
        projectID,
        formType,
        languageIsoCode,
        entityIDs,
    }) {
        return this.request('post', 'admin/translations/getTranslationModelList', {
            projectID,
            formType,
            languageIsoCode,
            entityIDs,
        });
    }

    saveTranslation({
        projectID,
        entityID,
        languageIsoCode,
        projectResourceID,
        formType,
        content,
    }) {
        return this.request('post', 'admin/translations/saveTranslation', {
            projectID,
            entityID,
            languageIsoCode,
            projectResourceID,
            formType,
            content,
        });
    }

    saveTranslationList({
        projectID,
        translations,
    }) {
        return this.request('post', 'admin/translations/saveTranslationList', {
            projectID,
            translations,
        });
    }
}
